<template>
    <fieldset>
        <legend>
            <span :class="['text-uppercase font-size-sm font-weight-bold', paddingLeft ? 'padding-left' : null]" v-html="title"></span>
        </legend>
        <slot></slot>
    </fieldset>
</template>
<script>
export default {
    name: 'Fieldset',
    props: {
        title: {
            type: String,
            required: true
        },
        paddingLeft: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style scoped>
.padding-left {
    padding-left: 1.25rem;
}
</style>